import * as React from "react";

const Testing = () => {
    return (
      <ol className="references">
        <li>
          Centers for Disease Control and Prevention. Getting tested. Reviewed
          June 22, 2022. Accessed May 7, 2024.
          <br />
          <a
            target="_blank"
            href="https://www.cdc.gov/hiv/basics/hiv-testing/getting-tested.html"
          >
            https://www.cdc.gov/hiv/basics/hiv-testing/getting-tested.html
          </a>
        </li>
        <li>
          AIDSVu. Local data: United States. Accessed February 8, 2024.{" "}
          <a
            target="_blank"
            href="https://aidsvu.org/local-data/united-states/"
          >
            https://aidsvu.org/local-data/united-states/
          </a>
        </li>
        <li>
          Centers for Disease Control and Prevention. HIV declines among young
          people and drives overall decrease in new HIV infections. Updated May
          23, 2023. Accessed February 8, 2024.{" "}
          <a
            target="_blank"
            href="https://www.cdc.gov/nchhstp/newsroom/2023/2021-hiv-incidence.html"
          >
            https://www.cdc.gov/nchhstp/newsroom/2023/2021-hiv-incidence.html
          </a>
        </li>
        <li>
          Centers for Disease Control and Prevention. National transgender HIV
          testing day – April 18. Reviewed March 20, 2024. Accessed May 7, 2024.
          <br className="d-block d-md-none" />{" "}
          <a
            target="_blank"
            href="https://www.cdc.gov/hiv/library/awareness/nthtd.html"
          >
            https://www.cdc.gov/hiv/library/awareness/nthtd.html
          </a>
        </li>
        <li>
          Centers for Disease Control and Prevention. HIV Prevention and Care for Transgender People. May 31, 2022. Accessed May 7, 2024.
          <br />
          <a
            target="_blank"
            href="https://www.cdc.gov/hiv/clinicians/transforming-health/index.html"
          >
            https://www.cdc.gov/hiv/clinicians/transforming-health/index.html
          </a>
        </li>
        <li>
          Henny KD, Zhu W, Huang YA, Townes A, Delaney KP, Hoover KW. HIV
          testing trends among people with commercial insurance or Medicaid -
          United States, 2014-2019. <i>MMWR Morb Mortal Wkly Rep</i>.
          2021;70(25):905-909.
        </li>
        <li>
          Pitasi MA, Delaney KP, Brooks JT, DiNenno EA, Johnson SD, Prejean J.
          HIV testing in 50 local jurisdictions accounting for the majority of
          new HIV diagnoses and seven states with disproportionate occurrence of
          HIV in rural areas, 2016-2017. <i>MMWR Morb Mortal Wkly Rep</i>.
          2019;68(25):561-567.
        </li>
        <li>
          Pitasi MA, Delaney KP, Oraka E, et al. Interval since last HIV test
          for men and women with recent risk for HIV infection – United States,
          2006-2016. <em>MMWR Morb Mortal Wkly Rep.</em> 2018;67(24):677-681.{" "}
          <a
            target="_blank"
            href="https://www.cdc.gov/mmwr/volumes/67/wr/mm6724a2.htm?s_cid=mm6724a2_e"
          >
            https://www.cdc.gov/mmwr/volumes/67/wr/mm6724a2.htm?s_cid=mm6724a2_e
          </a>
        </li>
        <li>
          Centers for Disease Control and Prevention. HIV in the southern United
          States. Published September 2019. Accessed May 7, 2024.
          <br />
          <a
            target="_blank"
            href="https://www.cdc.gov/hiv/pdf/policies/cdc-hiv-in-the-south-issue-brief.pdf"
          >
            https://www.cdc.gov/hiv/pdf/policies/cdc-hiv-in-the-south-issue-brief.pdf
          </a>
        </li>
        <li>
          National Institute of Allergy and Infectious Diseases. HIV/AIDS.
          Updated June 29, 2020. Accessed May 7, 2024.
          <br />
          <a
            target="_blank"
            href="https://www.niaid.nih.gov/diseases-conditions/hivaids"
          >
            https://www.niaid.nih.gov/diseases-conditions/hivaids
          </a>
        </li>
        <li>
          National Institute of Allergy and Infectious Diseases. HIV cure.
          Updated March 26, 2019. Accessed May 7, 2024.
          <br />
          <a
            target="_blank"
            href="https://www.niaid.nih.gov/diseases-conditions/hiv-cure-research"
          >
            https://www.niaid.nih.gov/diseases-conditions/hiv-cure-research
          </a>
        </li>
        <li>
          Wise JM, Ott C, Azuero A, et al. Barriers to HIV testing: patient and
          provider perspectives in the deep south. <em>AIDS Behav.</em>{" "}
          <span className="d-inline-block">2019;23(4):1062-1072.</span>
        </li>
        <li>
          KFF. 2017 national survey of young adults on
          HIV/AIDS: chart pack. November 30, 2017. Accessed May 7, 2024.
          <br />
          <a
            target="_blank"
            href="https://files.kff.org/attachment/Chartpack-National-Survey-of-Young-Adults-on-HIV/AIDS"
          >
            https://files.kff.org/attachment/Chartpack-National-Survey-of-Young-Adults-on-HIV/AIDS
          </a>
        </li>
        <li>
          Baumann KE, Hemmige V, Kallen MA, Street RL, Giordano TP, Arya M.
          Whether patients want it or not, physician recommendations will
          convince them to accept HIV testing.{" "}
          <em>J Int Assoc Provid AIDS Care.</em> 2018;17:2325957417752258.
        </li>
        <li>
          KFF. HIV testing in the United States. Published
          June 24, 2022. Accessed May 7, 2024.
          <br />
          <a
            target="_blank"
            href="https://www.kff.org/hivaids/fact-sheet/hiv-testing-in-the-united-states/"
          >
            https://www.kff.org/hivaids/fact-sheet/hiv-testing-in-the-united-states/
          </a>
        </li>
        <li>
          Centers for Disease Control and Prevention. Find an HIV test. Reviewed
          February 7, 2024. Accessed May 7, 2024.
          <br />
          <a
            target="_blank"
            href="https://www.cdc.gov/hiv/basics/hiv-testing/finding-tests.html"
          >
            https://www.cdc.gov/hiv/basics/hiv-testing/finding-tests.html
          </a>
        </li>
        <li>
          TakeMeHome. About. Accessed July 26, 2021.
          <br className="d-block d-md-none" />{" "}
          <a target="_blank" href="https://takemehome.org/about">
            https://takemehome.org/about
          </a>
        </li>
        <li>
          Branson BM, Handsfield HH, Lampe MA, et al. Revised recommendations
          for HIV testing of adults, adolescents, and pregnant women in
          health-care settings. <em>MMWR Recomm Rep.</em> 2006;55(RR-14):1-17;
          quiz CE1-4.
        </li>
        <li>
          Centers for Disease Control and Prevention. How Do I Screen for HIV?
          Reviewed June 1, 2023. Accessed May 7, 2024.
          <br />
          <a
            target="_blank"
            href="https://www.cdc.gov/hiv/clinicians/screening/how.html"
          >
            https://www.cdc.gov/hiv/clinicians/screening/how.html
          </a>
        </li>
        <li>
          Golub SA, Gamarel KE. The impact of anticipated HIV stigma on delays
          in HIV testing behaviors: findings from a community-based sample of
          men who have sex with men and transgender women in New York City.{" "}
          <em>AIDS Patient Care STDS.</em> 2013;27(11):621-627.
        </li>
        <li>
          Soh QR, Oh LYJ, Chow EPF, Johnson CC, Jamil MS, Ong JJ. HIV testing
          uptake according to opt-in, opt-out or risk-based testing approaches:
          A systematic review and meta-analysis. <i>Curr HIV/AIDS Rep</i>.
          2022;19(5):375-383.
        </li>
        <li>
          Centers for Disease Control and Prevention. Types of HIV tests.
          Reviewed June 22, 2022. Accessed May 7, 2024.
          <br />
          <a
            target="_blank"
            href="https://www.cdc.gov/hiv/basics/hiv-testing/test-types.html"
          >
            https://www.cdc.gov/hiv/basics/hiv-testing/test-types.html
          </a>
        </li>
      </ol>
    );
  }

export default Testing;